export default __webpack_public_path__ + "static/media/userAvatar.f0316f5b.svg";